import api from './api';

export const login = (credentials) => api.post('/auth/login', credentials);
export const register = (userData) => api.post('/auth/register', userData);
export const logout = () => api.post('/auth/logout');
export const refreshToken = () => api.post('/auth/refresh');
export const getMe = () => api.get('/auth/me');
export const updateProfile = (profileData) => api.put('/auth/profile', profileData);
export const getHistory = () => api.get('/auth/history');
export const getUsers = () => api.get('/auth/users');
export const updateUser = (id, userData) => api.put(`/auth/users/${id}`, userData);
export const deleteUser = (id) => api.delete(`/auth/users/${id}`);
export const enable2FA = () => api.post('/auth/2fa/enable');
export const verify2FA = (code) => api.post('/auth/2fa/verify', { code });
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, password) => api.post('/auth/reset-password', { token, password });
